/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

class Channel extends Route {
  @service declare appService: AppService;

  queryParams = {
    tab: { refreshModel: false },
    section: { refreshModel: true },
  };

  reactEnabled() {
    return this.appService.app.canStandalonePlatformAccessReactIntegrationPages;
  }
}

export default ReactRoute(Channel);
